var map = {
	"./medal1.png": "abb1",
	"./medal2.png": "1eef",
	"./medal3.png": "85d7",
	"./medal4.png": "8f81",
	"./medal5.png": "6c0f",
	"./medal6.png": "d0d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c97";